import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import HappyScreen from './happy';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import BrunchScreen from './brunch';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
    const [showbrunch, setShowBrunch] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
      const [showHappyHour, setshowHappyHour] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);
    const [steak, setSteak] = useState(false);
    const [tomahawk, settomahawk] = useState(false);
    const [dataMothers, setdataMothers] = useState(false);



         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);



      useEffect(() => {
            menus.map((item) => {
                if (item.id === 435) {
                setDataFood(item);
                }

                if (item.id === 597) {
                setdataMothers(item);
                }

                if (item.id === 434) {
                setSteak(item.menus);
                }
            });
      }, [menus]);
    
    useEffect(() => {
            if (steak) {
                steak.map((item) => {
                    if (item.id === 3724) {
                    settomahawk(item);
                    }
                });
                }
      }, [steak]);
    
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            setshowHappyHour(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setShowDetailProduct(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            setshowHappyHour(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setShowDetailProduct(false)
         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
                <div>
                    
                    <div  onClick={() => { setshowHappyHour(true)}}>
                        <img
                       
                        style={{
                            width: 90,
                            height: 110,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                           
                            marginTop: 1,
                            marginBottom: 10,
                            position: 'absolute', right: 0,
                            top: 100,
                             right: 30,
                            zIndex: 900,
                         
                            
                        }}
                        src={require('./assets/Objects.png')}
                    />
                    </div>
                    <div  onClick={() => { setShowBrunch(true)}}>
                        <img
                       
                        style={{
                            width: 100,
                            height: 110,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                                alignSelf: 'center',
                            
                            marginTop: 1,
                            marginBottom: 10,
                            position: 'absolute', right: 0,
                            top: 105,
                            right: 150,
                            zIndex: 100,
                            
                        }}
                        src={require('./assets/brunch.png')}
                    />
                    </div>

                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', position: 'relative', zIndex: 900, }}>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 390,
                            height: 110,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 1,
                                marginBottom: 10,
                            marginLeft: 20,
                            
                        }}
                        src={require('./assets/logo.png')}
                    />
                </div>
                <div style={{ display: 'flex', width: '100%',  position: 'relative', zIndex: 100,  paddingInline: 20, boxSizing: 'border-box' }}>
                       
                   
                    <div style={{ width: '60%' }} >

                            <div onClick={() => {
                                   setshowCategories(true)
                                }}>
                                <img
                             onContextMenu={(e) => e.preventDefault()}
                                style={{
                                    width: '100%',
                                    height: 210,
                                     pointerEvents: 'none',
                                    objectFit: 'contain',
                                borderRadius: 14,
                                    
                                }}
                                src={require('./assets/27_final.png')}
                        />
                        </div>
                        
                            <div onClick={() => {
                                    setShowHappy(true)
                                }}>
                                <img
                              onContextMenu={(e) => e.preventDefault()}
                            style={{
                                marginTop: 2,
                                    width: '100%',
                                height: 224,
                                    pointerEvents: 'none',
                                    objectFit: 'contain',
                                borderRadius: 14,
                                    
                                }}
                                src={require('./assets/drinks.png')}
                            />
                        </div>
                    </div>

                     <div style={{ width: '40%'}}>
                            <video
                             
                            src={require('./assets/banner_vertical.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                                marginTop: 1,
                                width: '100%',
                                height: 438,
                                objectFit: 'cover',
                                borderRadius: 14,
                               
                               
                            }}
                        />

                    </div>
                </div>
               
            </div>

            <div
                    onClick={() => {
                        // setShowListProduct(true)
                        // setdishs(dataMothers)
                         setShowDetailProduct(true)
                    setDataDish({ dish: tomahawk, alldish: steak, currentDish: tomahawk })
               }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                    paddingInline: 20,
                    boxSizing: 'border-box',
                    marginTop: 15
                    }}>
                    <img
                        onContextMenu={(e) => e.preventDefault()}
                        //src={require('./assets/bannerinferior.png')}
                        src={require('./assets/bannerinferior.png')}
                    style={{
                        width: '100%',
                        height: 174,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -10,
                         pointerEvents: 'none',
                        marginLeft: 5
                        
                        
                    }}
                    />
                {/* <img
                    src={require('./assets/banner.png')}
                    style={{
                        width: '100%',
                        height: 174,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -10,
                        marginLeft: 5
                        
                    }}
                    /> */}
                    <p style={{textAlign: 'center', color: 'white', fontSize: 12}}>(1)Please inform the waiter if you have any type of allergic condition (2) Price subject to change without notice (3) 18% gratuity will be added to Checks $100+</p>
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
                {showHappyHour && <HappyScreen setShowListProduct={setshowHappyHour} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
                {showBar && <BarScreen setShowBar={setShowBar} />}
                {showbrunch && <BrunchScreen setShowBrunch={setShowBrunch} />}
                
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;